import request from '@/utils/request'

export function fetchReceiptPolicyTableFileList(id) {
  return request({
    url: '/receipt/receipt/' + id + '/policy_table_files',
    method: 'get',
  })
}


export function getReceiptInfo(query) {
  return request({
      url: '/receipt/get-receipt-info',
      method: 'get',
      params: query
  })
}

export function getPolicyNumber(query) {
  return request({
      url: '/receipt/get-policy-number',
      method: 'get',
      params: query
  })
}


export function getReceiptPolicyNumber(query) {
  return request({
      url: '/receipt/get-receipt-policy-number',
      method: 'get',
      params: query
  })
}
